import { render } from "./FormLinkButton.vue?vue&type=template&id=0dadc4f6"
import script from "./FormLinkButton.vue?vue&type=script&lang=js"
export * from "./FormLinkButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__